import i18n from '../../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../../core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class StateSearch extends BaseModel {
  state_name = '';
  county_name = '';
  city_name = '';

  rules = {};

  attributeLabels = {
    state_name: i18n.t('State'),
    county_name: i18n.t('County'),
    city_name: i18n.t('City'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(StateSearch);
